<template>
  <div class="bg-white dark:bg-gray-900">
    <div class="md:border md:rounded-lg">
      <div class="p-4 flex items-center animate-pulse">
        <div
          class="w-7 h-7 bg-shimmer rounded-full me-3 dark:bg-gray-850"
        ></div>
        <div class="flex-grow">
          <div class="w-12 h-3 bg-shimmer rounded dark:bg-gray-850"></div>
          <div class="w-48 h-5 mt-1 bg-shimmer rounded dark:bg-gray-850"></div>
        </div>
      </div>
    </div>
  </div>
</template>
